import React from 'react'

// Icon SVG theo mockup: màu không phải kênh thông tin duy nhất, mỗi mức có hình riêng (BR-1.4)
const ICONS = {
    total: (
        <g>
            <rect x='1.5' y='3' width='13' height='10.5' rx='2' fill='none' stroke='currentColor' strokeWidth='1.4' />
            <path d='M1.5 6.5h13' stroke='currentColor' strokeWidth='1.4' />
        </g>
    ),
    not_overdue: (
        <g>
            <circle cx='8' cy='8' r='7' fill='#28a745' />
            <path d='M4.6 8.2 7 10.5l4.4-4.6' fill='none' stroke='#fff' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' />
        </g>
    ),
    near_overdue: (
        <g>
            <path d='M8 1.2 15.2 14H.8Z' fill='#ffc107' />
            <rect x='7.2' y='5.4' width='1.6' height='4.6' rx='.8' fill='#3a2a00' />
            <circle cx='8' cy='12' r='1' fill='#3a2a00' />
        </g>
    ),
    overdue: (
        <g>
            <circle cx='8' cy='8' r='7' fill='#dc3545' />
            <rect x='7.1' y='3.6' width='1.8' height='5.6' rx='.9' fill='#fff' />
            <circle cx='8' cy='11.6' r='1.1' fill='#fff' />
        </g>
    ),
    unknown: (
        <g>
            <circle cx='8' cy='8' r='7' fill='#adb5bd' />
            <path d='M6.2 6.1a1.9 1.9 0 1 1 2.6 1.8c-.5.2-.8.6-.8 1.1v.4' fill='none' stroke='#fff' strokeWidth='1.5' strokeLinecap='round' />
            <circle cx='8' cy='11.6' r='1' fill='#fff' />
        </g>
    ),
}

const TierIcon = ({ type, size = 16 }) => (
    <svg className='tierIcon' width={size} height={size} viewBox='0 0 16 16' aria-hidden='true'>{ICONS[type]}</svg>
)

export default TierIcon
